(function($) {
  function productSwatches() {
    var selectedColor = $('.selected-color').text();
    $(document).on('mouseenter click', '.swatch-element.color', function(e) {
      var $target = $(e.target);
      var color = $target.closest('.swatch-element').attr('aria-label');

      $('.selected-color').text(color);

      if (e.type == "click") {
        selectedColor = color;
      }
    });

    $(document).on('mouseleave', '.swatch-element.color', function(e) {
      $('.selected-color').text(selectedColor);
    });
  }

  function productVideos() {
    //console.log('ready');

    $('.three-column-videos .lazyframe').each(function() {
      var $video = $(this);

      var url = $video.data('src');
      var isYoutube = url.indexOf('youtube') !== -1;
      var video_id = $video.data('video-id');
      var src = '';

      if (isYoutube) {
        src = "https://www.youtube.com/embed/".concat(video_id).concat('?&autoplay=1');
      } else {
        src = "https://player.vimeo.com/video/".concat(video_id);
      }
      //console.log(src);
      $video.attr('data-src', src);
    });

    $(document).on('click', '.three-column-videos .button', function(e) {
      e.preventDefault();

      var $video = $(e.currentTarget).closest('.video').find('.lazyframe');
      var $caption = $(e.currentTarget).closest('.video').find('.caption');
      //console.log(e, $(e.currentTarget), $video);

      var iframe = `
        <iframe src="${$video.attr('data-src')}" frameborder="0" allowfullscreen></iframe>
    `;
      $video.append(iframe);
      $video.addClass('lazyframe--loaded');
      $caption.hide();
    });
  }

  const variantSelection = document.querySelector('variant-selection')
  if (variantSelection) {
    variantSelection.addEventListener('variant-change', (e) => {
      dealerVariant(e.detail.variant.id)
    })
  }

  function dealerVariant(variantId) {
    if (window.ProductVariantDealers.hasOwnProperty(variantId)) {
      const label = window.ProductVariantDealers[variantId]['label']
      const url = window.ProductVariantDealers[variantId]['url']
      $('[data-product-shop-dealer]').text(label)
      $('[data-product-shop-dealer]').attr('href', url)
      $('.shopify-product-form').addClass('show-dealer')
    } else {
      $('.shopify-product-form').removeClass('show-dealer')
    }
  }

  $(document).ready(function() {
    if (window.CurrentVariant && window.ProductVariantDealers.hasOwnProperty(window.CurrentVariant)) {
      dealerVariant(window.CurrentVariant)
    }

    productSwatches();
    productVideos();
    localizationSelect();
  });

  function localizationSelect() {
    $('[data-localization-select]').on('change', function(){
      $(this).closest('form').trigger('submit')
    })
  }

})(jQuery);


// https://sterlingbymusicman.com/products/sabre
if (document.querySelector('.klaviyo_form_trigger')) {
  document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
    var _klOnsite = window._klOnsite || [];
    _klOnsite.push(['openForm', 'TwEgzj']);
  });
}


